import Step02 from "./Step02";
import Step03 from "./Step03";
import Step04 from "./Step04";
import FinalStep from "./FinalStep";
import ErrorStep from "./ErrorStep";

export default function StepperContent({
  state,
  refetch,
  activeStep,
  handleNext,
  handleBack,
  handleClose,
  handleState,
}) {
  switch (activeStep) {
    case 1:
      return (
        <Step02
          state={state}
          refetch={refetch}
          handleNext={handleNext}
          handleBack={handleBack}
          handleState={handleState}
        />
      );
    case 2:
      return (
        <Step03
          state={state}
          refetch={refetch}
          handleNext={handleNext}
          handleBack={handleBack}
          handleState={handleState}
        />
      );
    case 3:
      return (
        <Step04
          state={state}
          refetch={refetch}
          handleNext={handleNext}
          handleBack={handleBack}
          handleState={handleState}
        />
      );
    case 4:
      return <FinalStep refetch={refetch} />;
    default:
      return <ErrorStep refetch={refetch} />;
  }
}
